import React from 'react'

function TopArtists() {
  return (
    <div className='flex flex-1 flex-col h-full justify-center items-center '>
      <img src={'https://media.tenor.com/v6j3qu9ZmMIAAAAd/funny-cat.gif'} alt={'cat'} 
      className='w-1/4 my-32'/>
    </div>
  )
}

export default TopArtists